<template>
    <div class="row">
        <div class="col titre">
            <h2>Partage</h2>
        </div>
    </div>
    <div class="row">
        <div class="col lbl">
            <label>Numéro de dossier :</label>
        </div>
        <div class="col txt">
            <p> {{ numeroCardex }} </p>
        </div>
        <div class="col lbl">
            <label>Catégorie :</label>
        </div>
        <div class="col txt">
            <p> {{ categorie }} </p>
        </div>
    </div>
    <div class="row">
        <div class="col lbl text-vertical-center">
            <label>Entité :</label>
        </div>
        <div class="col">
            <Dropdown
            v-model="entite"
            :options="entiteLibelles"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"
            :showClear="true"/>
        </div>
        <div class="col lbl text-vertical-center">
            <label>Site d'origine :</label>
        </div>
        <div class="col">
            <Dropdown 
            v-model="site"
            :options="siteLibelles"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"
            :showClear="true" />
        </div>
    </div>
    <div class="row">
        <div class="col lbl text-vertical-center">
            <label>Genre de partage :</label>
        </div>
        <div class="col">
            <Dropdown 
            v-model="genrePartage"
            :options="genrePartageLibelles"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"
            :showClear="true" />
        </div>
        <div class="col"/>
        <div class="col"/>
    </div>
    <div class="row border-white">
        <div class="col">
            <h5>Liste des intervenants</h5>
            <div v-if="intervenantsLoading == true" class="row">
                <div class="col">
                <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
                </div>
            </div>
            <div v-else>
                <ListBox v-model="intervenantsPossiblesSelectionnes" :options="intervenantsPossibles" 
                :multiple="true" :filter="true" listStyle="height:500px" style="width:100%" optionLabel="description">
                    <template #option="slotProps">
                        <h6>{{slotProps.option.description}}</h6>
                    </template>
                </ListBox>
            </div>
        </div>
        <div class="col-1 align-self-center">
            <div class="row partage-button">
                <Button
                icon="pi pi-angle-right p-button-icon"
                @click="possibleVersChoisis"
                />
            </div>
            <div class="row partage-button">
                <Button
                icon="pi pi-angle-double-right p-button-icon"
                @click="possibleVersChoisisTous"
                />
            </div>
            <div class="row partage-button">
                <Button
                icon="pi pi-angle-left p-button-icon"
                @click="choisisVersPossible"
                />
            </div>
            <div class="row partage-button">
                <Button
                icon="pi pi-angle-double-left p-button-icon"
                @click="choisisVersPossibleTous"
                />
            </div>
        </div> 
        <div class="col">
            <h5>Intervenants choisis</h5>
            <ListBox v-model="intervenantsChoisisSelectionnes" :options="intervenantsChoisis" 
            :multiple="true" :filter="true" listStyle="height:500px" style="width:100%" optionLabel="description">
                <template #option="slotProps">
                    <h6>{{slotProps.option.description}}</h6>
                </template>
            </ListBox>
        </div> 
    </div>
    <div class="row pt5">
        <div class="col">  
            <div v-if="sauvegardeEnCours == true" class="row">
                <div class="col">
                <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
                </div>
            </div>
            <div v-else>
                <Button label="Sauvegarder" v-on:click="sauvegarder"/>
            </div>
        </div>
        <div class="col">
            <Button label="Retour" v-on:click="retour"/>
        </div>
    </div>
</template>
<script>

import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            numeroCardex: null,
            categorie: null,
            genrePartage: null,
            entite: null,
            site: null,
            genrePartageLibelles: [
                {valeur:'RES', texte:'Restreint'},
                {valeur:'OUV', texte:'Ouvert'}
            ],
            intervenantsLoading: false,
            sauvegardeEnCours: false,
            entiteLibelles: [],
            siteLibelles: [],
            intervenantLibelles: [],
            intervenantsPossiblesSelectionnes: [],
            intervenantsPossibles: [],
            intervenantsChoisis: [],
            intervenantsChoisisSelectionnes: []

        };
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
        })
    },
    mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Ajouter Partage");
        this.genrePartage = this.genrePartageLibelles[0].valeur;
        this.$store.dispatch('dossier/rechercherDefaut48HeuresAction').then((res) => {
            this.entiteLibelles = res.data.entiteDecision.entite.libelles;
            this.entite = Number(this.$route.params.entite);
            this.site = Number(this.$route.params.site);
            this.$store.dispatch('dossier/recupererAction', {
                cle: this.$route.params.cle,
                site: this.$route.params.site
            }).then((res) => {
                this.numeroCardex = res.data.entite.numeroCardex;
                this.categorie = res.data.entite.categorieAfficher;
            });
        });
        this.$store.dispatch('dossier/obtenirIntervenantsPartagesAction', {
            cle: this.$route.params.cle,
            site: this.$route.params.site
        }).then((res) => {
            this.intervenantsChoisis = res.data;
            this.isDataLoading = false;
        });
    },
    methods: {
        possibleVersChoisis() {
            this.intervenantsChoisis = this.intervenantsChoisis.concat(this.intervenantsPossiblesSelectionnes);
            this.intervenantsPossibles = this.filtrerIntervenants(this.intervenantsPossibles, this.intervenantsPossiblesSelectionnes);
            this.intervenantsPossiblesSelectionnes = [];
            this.intervenantsChoisisSelectionnes = [];
        },
        possibleVersChoisisTous() {
            this.intervenantsChoisis = this.intervenantsChoisis.concat(this.intervenantsPossibles);
            this.intervenantsPossibles = [];
            this.intervenantsPossiblesSelectionnes = [];
            this.intervenantsChoisisSelectionnes = [];
        },
        choisisVersPossible() {
            this.intervenantsPossibles = this.intervenantsPossibles.concat(this.intervenantsChoisisSelectionnes);
            this.intervenantsChoisis = this.filtrerIntervenants(this.intervenantsChoisis, this.intervenantsChoisisSelectionnes);
            this.intervenantsPossiblesSelectionnes = [];
            this.intervenantsChoisisSelectionnes = [];
        },
        choisisVersPossibleTous() {
            this.intervenantsPossibles = this.intervenantsPossibles.concat(this.intervenantsChoisis);
            this.intervenantsChoisis = [];
            this.intervenantsPossiblesSelectionnes = [];
            this.intervenantsChoisisSelectionnes = [];
        },
        filtrerIntervenants(intervenants, intervenantsToFilter){
            var intervenantsFiltered = [];
            for(let i = 0; i < intervenants.length; i++){
                var currentIntervenant = intervenants[i];
                const duplicate = intervenantsToFilter.some(intervenant => intervenant.codeProfil === currentIntervenant.codeProfil);
                if(!duplicate){
                    intervenantsFiltered.push(currentIntervenant);
                }
            }
            return intervenantsFiltered;
        },
        retour(){
            this.$root.$refs.breadcrumbComp.rediriger();
        },
        sauvegarder(){
            this.sauvegardeEnCours = true;
            this.intervenantsChoisis.forEach(current => {
                current.genrePartage = this.genrePartage;
            });
            this.$store.dispatch('dossier/ajouterIntervenantsPartagesAction', 
            { intervenants : this.intervenantsChoisis,
              cle: this.$route.params.cle,
              site: this.$route.params.site})
            .then(() => {
                this.sauvegardeEnCours = false;
            }).catch(() => {
                this.sauvegardeEnCours = false;  
            });
            this.$router.back();
        }
    },
    watch: {
        entite: function(val, oldVal) {
        if (val !== null && val !== undefined) {
            this.$store.dispatch('dossier/onChangeEntityAction', {
            libelleChange: 'Site',
            nouvelleValeur: [val]
            })
            .then((res) => {
                this.siteLibelles = res.data;
                if(oldVal != undefined){
                    this.site = null;
                }
            });
        } else {
            this.site = null;
            this.siteLibelles = [];
        }
        },
        site: function(val) {
        if(val !== null && val !== undefined){
            this.intervenantsLoading = true;
            this.$store.dispatch('dossier/obtenirListeIntervenantsPourPartageAction', {
            site: val
            })
            .then((res) => {
                this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
                this.intervenantsPossibles = this.intervenantLibelles;
                this.intervenantsLoading = false;
            });      
        }else{
            this.intervenantLibelles = [];
            this.intervenant = null;
        }
        },
    }
}
</script>
